import React from 'react';
import { Row } from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { CreditCardFormSection } from '../CreditCardFormSection';
import { MicroformCreditcardNumber } from '../fields/MicroformCreditcardNumber';
import { MicroformCVV } from '../fields/MicroformCVV';
import { MicroformExpiryDate } from '../fields/MicroformExpiryDate';

export const CreditCardInfo = () => {
	const { t } = useTranslation();

	return (
		<CreditCardFormSection title={t('payment_form_credit_card_info')}>
			<Row>
				<MicroformCreditcardNumber />
				<MicroformExpiryDate />
				<MicroformCVV />
			</Row>
		</CreditCardFormSection>
	);
};
